interface ISettings {
  title: string // 覆盖默认标题
  showSettings: boolean // 控件设置面板显示
  showTagsView: boolean // 控制tagsview显示
  showSidebarLogo: boolean // 控件图标显示
  fixedHeader: boolean // If true, will fix the header component
  errorLog: string[] // The env to enable the errorlog component, default 'production' only
  sidebarTextTheme: boolean // If true, will change active text color for sidebar based on theme
  devServerPort: number // webpack-dev-server的端口号
  mockServerPort: number // Port number for mock server
}

// You can customize below settings :)
const settings: ISettings = {
  title: 'Admin System',
  showSettings: true,
  showTagsView: true,
  fixedHeader: true,
  showSidebarLogo: false,
  errorLog: ['production'],
  sidebarTextTheme: true,
  devServerPort: 9000,
  mockServerPort: 9528
}

export default settings
